<template>
    <div class="p-home | l-inner">
        <app-section
            :title="pageHeading"
            :desc="page.description || page.titre_de_corps || []"
            bgIntro="lighter"
            :image="page.image_hero"
            intro-position="bottom"
            :image-has-background="true"
            :hide-hero-overlay="page.hide_hero_overlay === true"
        >
            <template #content>
                <div class="l-grid">
                    <template v-for="(slice, index) in page.body || []">
                        <hero-card v-if="slice.slice_type === 'card'" :key="index" :data="slice" />
                        <entrepreneur-title-text
                            v-else-if="slice.slice_type === 'title_text'"
                            :key="index"
                            :data="slice"
                        />
                        <social-medias-block
                            v-else-if="slice.slice_type === 'social_medias'"
                            :key="index"
                            :data="slice"
                        />
                        <entrepreneur-parallax
                            v-else-if="slice.slice_type === 'parallax'"
                            :key="index"
                            :data="slice"
                        />
                    </template>
                </div>
            </template>
        </app-section>
        <about />
    </div>
</template>

<script>
import About from "layout/About";
import AppSection from "layout/AppSection";
import EntrepreneurParallax from "components/EntrepreneurParallax/EntrepreneurParallax";
import EntrepreneurTitleText from "components/EntrepreneurTitleText/EntrepreneurTitleText";
import HeroCard from "components/HeroCard/HeroCard";
import SocialMediasBlock from "components/SocialMediasBlock/SocialMediasBlock";

export default {
    name: "Home",
    components: {
        About,
        AppSection,
        EntrepreneurParallax,
        EntrepreneurTitleText,
        HeroCard,
        SocialMediasBlock,
    },
    props: {
        page: Object,
    },
    computed: {
        pageHeading() {
            const heading = this.page.heading;
            if (heading && heading[0] && heading[0].text) {
                return heading[0].text;
            }
            return this.page.title || "";
        },
    },
};
</script>

<style lang="scss">
.p-home .o-card-video__inner__title {
    max-width: 15em;
}

// "Maintenant." on Donner du sens is the wide line of this heading
.p-home .c-entrepreneur-title-text-title__title h2 {
    max-width: 9em;
}
</style>
